// extracted by mini-css-extract-plugin
export default {"overdueDate":"DashboardUpdatedRecently_overdueDate__e8-mI"};